const en = {
  ADMINPANEL_CONTACT: "Contact tabs",
  ADMINPANEL_COUNTRYFIX: "Country correction",
  ADMINPANEL_EDIT: "@it functions",
  ADMINPANEL_RIGHTS: "Permissions",
  ADMINPANEL_TITLE: "Administration",
  CAMPAIGN_ACTION_DATE: "Date",
  CAMPAIGN_ACTION_DELETEFILE_ALERT: "Do you really want to delete file attachment '{0}'?",
  CAMPAIGN_ACTION_DELETEFILE_TT: "Delete file",
  CAMPAIGN_ACTION_DESC: "Description",
  CAMPAIGN_ACTION_DOWNLOADFILE_TT: "Download file",
  CAMPAIGN_ACTION_FILES_TITLE: "File attachments",
  CAMPAIGN_ACTION_NEW_ATTACHMENT: "New attachment...",
  CAMPAIGN_ACTION_PRINT_TITLE: "Print mailing",
  CAMPAIGN_ACTION_TITLE: "Campaign event",
  CAMPAIGN_CHART_WARNING_ALLINVISIBLE: "Currently no campaigns are shown in the chart.\nCampaigns with an end date older than 30 days are hidden by default.\nUse the button 'Select campaigns' in the bottom left to add any campaigns to the chart.",
  CAMPAIGN_CHART_WARNING_NOCAMPAIGNS: "No campaigns are stored in the database.",
  CAMPAIGN_ENDDATE: "End date: {0}",
  CAMPAIGN_FIRST_DISPATCH: "first dispatch date",
  CAMPAIGN_GUI_BT_OPTIONS: "Select campaigns",
  CAMPAIGN_GUI_BT_POPUP_APPLY: "Apply selection",
  CAMPAIGN_GUI_BT_POPUP_TEXT: "Select campaigns to be displayed on the dashboard. ",
  CAMPAIGN_GUI_BT_REFRESH: "Refresh dashboard",
  CAMPAIGN_GUI_SLIDER_3MONTHS: "3 months",
  CAMPAIGN_GUI_SLIDER_DESC: "Zoom factor",
  CAMPAIGN_GUI_SLIDER_HALFYEAR: "6 months",
  CAMPAIGN_GUI_SLIDER_MONTH: "1 month",
  CAMPAIGN_GUI_SLIDER_YEAR: "1 year",
  CAMPAIGN_GUI_TOOLTIP_DATE: "Date:",
  CAMPAIGN_GUI_TOOLTIP_NAME: "Name:",
  CAMPAIGN_GUI_TOOLTIP_NUM_MAIL: "Number of mailings:",
  CAMPAIGN_GUI_TOOLTIP_NUM_PRINT: "Number of print mailings:",
  CAMPAIGN_GUI_TOOLTIP_OWNER: "Owner:",
  CAMPAIGN_GUI_TOOLTIP_PERIOD: "Period:",
  CAMPAIGN_GUI_TOOLTIP_STATUS: "Status:",
  CAMPAIGN_INVALID_PERIOD: "The selected campaign period is invalid.",
  CAMPAIGN_INVALID_PERIOD_TITLE: "Invalid period",
  CAMPAIGN_LAST_DISPATCH: "last dispatch date",
  CAMPAIGN_MISSING_DATES: "Start and end date must be filled in.",
  CAMPAIGN_NAME: "Name",
  CAMPAIGN_NUM_MAILINGS: "Number of mailings",
  CAMPAIGN_NUM_PRINTMAILINGS: "Number of print mailings",
  CAMPAIGN_RANGE: "Start date - end date",
  CAMPAIGN_STARTDATE: "Start date: {0}",
  CAMPAIGN_SWAPPED_DATES: "The end date lies before the start date.",
  CAMPAIGN_TITLE: "Campaign",
  CAMPAING_DISPATCH_OUTSIDE_WARN: "This campaign contains mailings with a dispatch date outside of the campaign period.",
  CONTACT: "Contact",
  CONTACT_ACCOUNT_NAME: "Account name",
  CONTACT_ADDRESS: "Address",
  CONTACT_ADDRESS_FROM_COMPANY: "retrieve from company",
  CONTACT_BROWSE_MARKED: "marked",
  CONTACT_BROWSE_OF: "{0} of {1}",
  CONTACT_CATEGORIES: "Categories",
  CONTACT_CLEAR_DATE_FF_TT: "Clear date",
  CONTACT_COMPANY_SHOW_EMPLOYEES: "Show all employees of this company as a search result.",
  CONTACT_COPY_CLIPBOARD_TT: "Copy business card to system clipboard",
  CONTACT_CLIPBOARD_OK_SB: "Copied",
  CONTACT_CLIPBOARD_ERROR_SB: "Can not copy",
  CONTACT_CORPORATE: "Corporate",
  CONTACT_COUNTRY_AUTOCORRECT_TT: "The country was corrected automatically. Save the contact to apply the changes.",
  CONTACT_CREATED: "Created",
  CONTACT_DELETE_ACCOUNTS: "Also delete user accounts",
  CONTACT_DELETE_ALERT: "Do you really want to delete this contact permanently from the database?",
  CONTACT_DROPPED_FROM_RESULT: "Due to modifications this contact is no longer part of the displayed search results.",
  CONTACT_DUPLICATE: "Duplicate",
  CONTACT_DUPLICATION_PROCESS: "A duplicate of this contact has been prepared. When you click Save, a new record will be created in the database. Prior to saving you should adjust the personal data and double-check whether the information in custom fields and categories still applies.",
  CONTACT_FREE_FIELDS: "Custom fields",
  CONTACT_GENDER_FEMALE: "Mrs",
  CONTACT_GENDER_MALE: "Mr",
  CONTACT_GENDER_UNKNOWN: "[unknown]",
  CONTACT_IMPORT_VCARD: "Import vCard",
  CONTACT_INVALID_COUNTRY_TT: "The country field contains an unknown value. Please choose a valid country.",
  CONTACT_MAIN_DATA: "Master Data",
  CONTACT_MODIFIED: "Last modification",
  CONTACT_NEWSLETTER_BOUNCED: "email could not be delivered (bounce)",
  CONTACT_NOTES: "Notes",
  CONTACT_NOTES_CLIPBOARD_OK_SB: "Notes copied",
  CONTACT_NOTES_CLIPBOARD_ERROR_SB: "Can not copy notes",
  CONTACT_NOTES_MERGED_SUIDS: "SUID from merge",
  CONTACT_NOTES_RESUB_LABEL: "Resubmission for {0}",
  CONTACT_NOTES_RESUB_POPUP_BTN_CHANGE: "Apply date",
  CONTACT_NOTES_RESUB_POPUP_BTN_REMOVE: "Remove resubmission",
  CONTACT_NOTES_RESUB_POPUP_DATE: "Due date",
  CONTACT_NOTES_RESUB_POPUP_DONE: "done",
  CONTACT_NOTES_RESUB_POPUP_DONE_TT: "A resubmission marked as done is not displayed in the list on the dashboard and will not be included in the daily reminder email.",
  CONTACT_NOTES_RESUB_POPUP_FOR: "Resubmission for",
  CONTACT_NOTES_RESUB_POPUP_TEXT: "Comment",
  CONTACT_NOTES_RESUB_POPUP_TITLE: "Resubmission date",
  CONTACT_NOTES_RESUB_POPUP_WARNING: "The chosen date is in the past",
  CONTACT_NOTES_RESUB_POPUP_WARNING_TITLE: "Warning",
  CONTACT_NOTES_SAVE_FIRST: "In order to attach notes the new contact must be saved first.",
  CONTACT_NOTE_DELETE_ALERT: "Do you really want to delete this note?",
  CONTACT_NOTE_DELETE_TT: "Delete entry",
  CONTACT_NOTE_EDIT_TT: "Edit entry",
  CONTACT_NOTE_MODIFIED_ON: "modified",
  CONTACT_NOTE_NEW: "New note",
  CONTACT_NOTE_NEW_RESUB: "New resubmission",
  CONTACT_NOTE_RESUB_DATE: "Due date: {0}",
  CONTACT_NOTE_RESUB_DONE: "done?",
  CONTACT_NOTE_RESUB_DONE_TT: "Mark the resubmission as completed in order to deactivate the reminder.",
  CONTACT_NOTE_SAVE_TT: "Save note",
  CONTACT_NOTE_TO_CLIPBOARD_TT: "Copy all notes to system clipboard.",
  CONTACT_NOTE_UNDO_TT: "Cancel editing",
  CONTACT_NOT_FOUND_ALERT: "A contact could not be loaded. Possibly it has been deleted by a different user in a concurrent session.",
  CONTACT_NOT_FOUND_TITLE: "Missing record",
  CONTACT_PHOTO_DELETE_ALERT: "Do you really want to delete the image permanently?",
  CONTACT_PHOTO_DELETE_BTN: "Delete image",
  CONTACT_PHOTO_DOESNT_EXIST: "No image attached",
  CONTACT_PHOTO_SAVE_FIRST: "Your recent changes must be saved before opening the image viewer.",
  CONTACT_PHOTO_UPLOAD_BTN: "Replace image",
  CONTACT_PHOTO_VIEW_TITLE: "Contact image",
  CONTACT_RESUBMISSIONS_ON: "Resubmissions active!",
  CONTACT_SEND_EMAIL_TT: "Send email to this contact",
  CONTACT_SHOW_TAB_TT: "Show in tab '{0}'",
  CONTACT_STANDARD_FIELDS: "Master Data",
  COUNTRYFIX_BTN_FIX_TT: "Replace country",
  COUNTRYFIX_BTN_SHOW_TT: "Show contacts",
  COUNTRYFIX_COL_COUNT: "Contacts",
  COUNTRYFIX_COL_TEXT: "Invalid country",
  COUNTRYFIX_DIALOG_APPLY: "Apply",
  COUNTRYFIX_DIALOG_CHOOSE_PROMPT: "Choose country...",
  COUNTRYFIX_DIALOG_HEADER: "Replace country",
  COUNTRYFIX_DIALOG_REPLACEBY: "replace by",
  COUNTRYFIX_DIALOG_WARNING: "Number of affected contacts: {0}",
  COUNTRYFIX_TITLE: "Country correction",
  CUSTOMTABCONFIGPANEL_ALERT_TEXT: "The selected field is already used on tab '{0}'. Do you want to remove it from there and insert it here?",
  CUSTOMTABCONFIGPANEL_ALERT_TITLE: "Move field",
  CUSTOMTABCONFIGPANEL_BTCHANGES: "Save configuration",
  CUSTOMTABCONFIGPANEL_BTLANGUAGES: "Other languages...",
  CUSTOMTABCONFIGPANEL_POPUP_HEAD: "Tab titles in different languages",
  CUSTOMTABCONFIGPANEL_POPUP_LANGUAGE: "Language",
  CUSTOMTABCONFIGPANEL_POPUP_TITLE: "Title",
  CUSTOMTABCONFIGPANEL_TAB_CATEGORIES_TEXT: "The list below shows all fields which are displayed on the tab 'Categories' of a contact.",
  CUSTOMTABCONFIGPANEL_TAB_CUSTOMITEM_BTDELETE: "Delete Tab",
  CUSTOMTABCONFIGPANEL_TAB_CUSTOMITEM_LABEL: "*New tab",
  CUSTOMTABCONFIGPANEL_TAB_CUSTOMITEM_TEXT: "Configure the list with elements from the list beside",
  CUSTOMTABCONFIGPANEL_TAB_CUSTOMITEM_TILABEL: "Please enter the name of the tab",
  CUSTOMTABCONFIGPANEL_TAB_FREEFIELDS_TEXT: "The list below shows all fields which are displayed on the tab 'Custom fields' of a contact.",
  CUSTOMTABCONFIGPANEL_TITLE: "Contact tabs configuration",
  CUSTOMTABCONFIGPANEL_TOGGLE_ALL: "All fields",
  CUSTOMTABCONFIGPANEL_TOGGLE_UNUSED: "Unused fields",
  DASHBOARD_BT_CAMPAIGNS: "Campaigns",
  DASHBOARD_BT_MAILINGS: "Mailings",
  DASHBOARD_BT_MYDASH: "My Dashboard",
  DASHBOARD_BT_REPORTING: "Reporting",
  DB_ACCOUNTID: "Account ID",
  DB_ACCOUNTNAME: "Account name",
  DB_ARCHIVED: "Archived address",
  DB_BOUNCED: "email bounced",
  DB_CITY: "Town",
  DB_CITY2: "Town 2",
  DB_REGION: "Region",
  DB_COMPANY: "Company",
  DB_COMPANY2: "Company 2",
  DB_COMPANY3: "Company 3",
  DB_COMPANY4: "Company 4",
  DB_COMPANYEXT: "Company 2", // not used
  DB_COUNTRY: "Country",
  DB_CREATED: "Creation date",
  DB_CREATEDLABEL: "Creation date",
  DB_DIVISION: "Division",
  DB_EMAIL: "email",
  DB_FAX: "Fax",
  DB_FIRSTNAME: "First name",
  DB_GENDER: "Salutation",
  DB_GENDERLABEL: "Salutation",
  DB_HOMEPAGE: "Homepage",
  DB_ID: "ID",
  DB_LASTNAME: "Last name",
  DB_MOBILE: "Mobile",
  DB_MODIFICATIONDATE: "Modification date",
  DB_MODIFIEDLABEL: "Modification date",
  DB_NEWSLETTER: "emails enabled",
  DB_PHONE: "Phone",
  DB_POBOX: "P.O. Box",
  DB_POSITION: "Position",
  DB_REGID: "RegID",
  DB_SECONDNAME: "Second name",
  DB_STATE: "State",
  DB_STREET: "Street",
  DB_STREET2: "Street 2",
  DB_STREET3: "Street 3",
  DB_STREET4: "Street 4",
  DB_HOUSE_NO: "House Nr.",
  DB_SUID: "SUID",
  DB_TITLE: "Title",
  DB_TITLE2: "Title 2",
  DB_ZIPPOBOX: "Postcode 2",
  DB_ZIPSTREET: "Postcode",
  DIALOG_RENAME_NAME_LABEL: "Name",
  EASYSELECT_CATEGORY_ADD_ERROR_CONTENT: "A category with that name already exists.",
  EASYSELECT_CATEGORY_NEW_ENTRY_NOTE: "new category",
  EASYSELECT_CATEGORY_PANEL_ADD_BT: "Add category",
  EASYSELECT_CATEGORY_PANEL_ADD_PROMPT: "Category",
  EASYSELECT_CATEGORY_PANEL_CB_TT: "Select the new category directly",
  EASYSELECT_CATEGORY_PANEL_TITLE: "Add new category",
  EASYSELECT_CATEGORY_PANEL_TT_PROMPT: "Description",
  EASYSELECT_CATEGORY_PANEL_TT_TT: "You can enter a short explanation of the category here which will be displayed as a hint icon.",
  EASYSELECT_CATEGORY_UNSAVED_CHANGES_CONTENT_MANY: "You have added {0} new categories. Do you want to apply your changes now?",
  EASYSELECT_CATEGORY_UNSAVED_CHANGES_CONTENT_ONE: "You have added a new category. Do you want to apply your changes now?",
  EASYSELECT_CATEGORY_UNSAVED_CHANGES_TITLE: "New categories",
  EASYSELECT_CB_OPEN_BUTTON_TT: "Open selection in a separate window",
  EASYSELECT_DEFAULT_TITLE: "Please make a selection",
  EASYSELECT_FILTER_FAIR_CHECK: "Fair prefix",
  EASYSELECT_FILTER_FAIR_CHECK_TT: "Select this checkbox to activate filtering by fair prefix.",
  EASYSELECT_FILTER_FAIR_TT: "Filter values by fair prefix (e.g. fair2014).",
  EASYSELECT_FILTER_TEXT_TT: "Filter values by typing free text.",
  EASYSELECT_PROMPT: "Click to select...",
  EASYSELECT_SELECT_ALL: "Select all",
  EASYSELECT_SELECT_NONE: "Select none",
  ERROR_CLOSE: "Close",
  ERROR_COPY_CLIPBOARD_TT: "Copy error message to system clipboard",
  ERROR_DETAILS: "Details...",
  ERROR_DUPLICATE_CAMPAIGN_NAME: "The campaign could not be saved, because there is already a campaign with the given name.",
  ERROR_HEADING: "Error",
  ERROR_IMPORT_VCARD: "The vCard could not be imported.",
  ERROR_INTERNAL: "An unexpected error occured in the user interface. In case the CRM does not work properly anymore, please refresh your browser window.",
  ERROR_INVALID_RESPONSE: "A server-side error occurred. The response is invalid.",
  ERROR_SAVE_CONTACT: "The contact could not be saved. Possibly it has been deleted by a different user in a concurrent session.",
  ERROR_SERVER_FAILED: "Server communication failure. Should this problem persist, please contact your systems administrator.",
  ERROR_UNEXPECTED_RESPONSE: "A server-side error occurred. The response has an unknown status code.",
  ERROR_UNSPECIFIED: "Unexpected error",
  ERROR_RIGHTS: "No rights to access this resource. Please check the permission settings.",
  EXPORT_CATEGORY_VALUES: "...within a column",
  EXPORT_COLUMNS: "...between columns",
  EXPORT_CONFIGURATION: "Export configuration",
  EXPORT_DELETE_ALERT: "Do you really want to delete export configuration '{0}'?",
  EXPORT_DELETE_CONFIG: "Delete",
  EXPORT_DRAG_HERE: "Please drag the required fields into this area.",
  EXPORT_ENCODING: "Encoding",
  EXPORT_EXPERT_SETTINGS: "Advanced Settings",
  EXPORT_FIELD_COUNTRY_ID: "Country code",
  EXPORT_FIELD_COUNTRY_NAME: "Country",
  EXPORT_FORMAT: "Export format",
  EXPORT_HINT_ALL_INCLUDED: "All fields have been included",
  EXPORT_HINT_INCLUDE: "Include at least one field to export",
  EXPORT_INVALID_ALERT_TITLE: "Invalid export",
  EXPORT_INVALID_NOFIELDS: "This is not a valid configuration, because no fields have been selected.",
  EXPORT_INVALID_SEPARATORS: "This is not a valid configuration. Please check the separators in the 'Advanced settings'.",
  EXPORT_NEW_CONFIG: "[New configuration]",
  EXPORT_NUM_SELECTED_FIELDS: "Selected: {0}",
  EXPORT_NUMBER_INCLUDED: "Number of included contacts: {0}",
  EXPORT_RENAME_CONFIG: "Rename export configuration",
  EXPORT_RENAME_HEADER: "Rename export configuration",
  EXPORT_RUN_CSV: "Export to CSV",
  EXPORT_RUN_EXCEL: "Export to Excel",
  EXPORT_SAVEAS_HEADER: "Save export configuration",
  EXPORT_SAVE_CONFIG: "Save export configuration",
  EXPORT_SELECT_CONFIG: "Select configuration",
  EXPORT_SEPARATOR_COLUMNS: "[separate columns]",
  EXPORT_SEPARATOR_COMMA: "comma",
  EXPORT_SEPARATOR_FOR: "Separator",
  EXPORT_SEPARATOR_BETWEEN: "Separator between columns",
  EXPORT_SEPARATOR_WITHIN: "Separator within columns",
  EXPORT_SEPARATOR_FREE_CHAR: "[custom...]",
  EXPORT_SEPARATOR_FREE_CHAR_LABEL: "custom",
  EXPORT_SEPARATOR_SEMICOLON: "semicolon",
  EXPORT_SEPARATOR_TAB: "tabulator",
  EXTSEARCH_ADD_CONTACT: "Add contact",
  EXTSEARCH_ADD_SEARCH_BLOCK: "Add search block",
  EXTSEARCH_CONFIG: "Search configuration",
  EXTSEARCH_CONFIG_GROUP: "Contacts",
  EXTSEARCH_DATEINPUT_DAY: "Day",
  EXTSEARCH_DATEINPUT_HOUR: "Hour",
  EXTSEARCH_DATEINPUT_MINUTE: "Minute",
  EXTSEARCH_DATEINPUT_MONTH: "Month",
  EXTSEARCH_DATEINPUT_YEAR: "Year",
  EXTSEARCH_DELETE_ALERT: "Do you really want to delete this saved search?",
  EXTSEARCH_DELETE_ALERT_GROUP: "Do you really want to delete this contact group?",
  EXTSEARCH_ELEMENT_AND: "AND",
  EXTSEARCH_ENTER_NAME: "Please enter a name for this search.",
  EXTSEARCH_ENTER_NAME_TITLE: "Missing name",
  EXTSEARCH_GROUP_COUNT: "Contacts",
  // EXTSEARCH_INVALID: "This is not a valid search configuration. Please choose at least one search field.",
  EXTSEARCH_INVALID: "This is not a valid search configuration.",
  EXTSEARCH_INVALID_FIELD: "Please choose at least one search field.",
  // EXTSEARCH_INVALID_CATEGORY: "This is not a valid search configuration. Please select at least one value when using 'is one of' or 'is not one of'.",
  EXTSEARCH_INVALID_CATEGORY: "Please select at least one value when using 'is one of' or 'is not one of'.",
  // EXTSEARCH_INVALID_DATE: "This is not a valid search configuration. Please enter a valid date.",
  EXTSEARCH_INVALID_DATE: "Please enter a valid date.",
  EXTSEARCH_INVALID_GROUP: "Please give a name to this contact group",
  EXTSEARCH_INVALID_TITLE: "Invalid search",
  EXTSEARCH_MULTITEXT_OR: "or",
  EXTSEARCH_NAME: "Name of search",
  EXTSEARCH_NAME_GROUP: "Name of group",
  EXTSEARCH_NOTES_ITEM: "Note",
  EXTSEARCH_NOTES_SEPARATOR: "Other",
  EXTSEARCH_OBSOLETE_IDS_CATLIST: "Obsolete category lists",
  EXTSEARCH_OBSOLETE_IDS_CATVALUE: "Obsolete category values",
  EXTSEARCH_OBSOLETE_IDS_FF: "Obsolete free fields",
  EXTSEARCH_OBSOLETE_TEXT: "This saved search contains obsolete fields, which do not exist any more in the system. These fields are not displayed in the search configuration. Save this search again in order to remove all references to the obsolete fields.",
  EXTSEARCH_OBSOLETE_TITLE: "Obsolete fields",
  EXTSEARCH_OP_BEGINSWITH: "starts with",
  EXTSEARCH_OP_BEGINSWITHNOT: "doesn't start with",
  EXTSEARCH_OP_CONTAINS: "contains",
  EXTSEARCH_OP_CONTAINSNOT: "doesn't contain",
  EXTSEARCH_OP_DATE_AFTER: "is after",
  EXTSEARCH_OP_DATE_BEFORE: "is before",
  EXTSEARCH_OP_DATE_ON: "is on",
  EXTSEARCH_OP_ENDSWITH: "ends with",
  EXTSEARCH_OP_ENDSWITHNOT: "doesn't end with",
  EXTSEARCH_OP_IS: "is",
  EXTSEARCH_OP_ISCHECKED: "is checked",
  EXTSEARCH_OP_ISCHECKEDNOT: "is not checked",
  EXTSEARCH_OP_ISEMPTY: "is empty",
  EXTSEARCH_OP_ISEMPTYNOT: "isn't empty",
  EXTSEARCH_OP_ISGREATER: "is greater",
  EXTSEARCH_OP_ISGREATEREQUAL: "is greater or equal",
  EXTSEARCH_OP_ISIN: "is one of",
  EXTSEARCH_OP_ISINNOT: "is not one of",
  EXTSEARCH_OP_ISLESS: "is less",
  EXTSEARCH_OP_ISLESSEQUAL: "is less or equal",
  EXTSEARCH_OP_ISNOT: "isn't",
  EXTSEARCH_PREVIEW_GROUP: "Show as search result",
  EXTSEARCH_PREVIEW_SEARCH: "Run search",
  EXTSEARCH_REMOVE_BLOCK_TT: "Remove search block",
  EXTSEARCH_RESET_ALERT: "Do you really want to reset the search configuration?",
  EXTSEARCH_SAVEAS_HEADER: "Save extended search",
  EXTSEARCH_SAVEAS_HEADER_GROUP: "Save contact group",
  EXTSEARCH_SEARCH_BLOCK_OR: "OR",
  EXTSEARCH_SELECT_SEARCH_FIELD: "[Select field...]",
  EXTSEARCH_TITLE: "Extended Search",
  EXTSEARCH_TITLE_GROUP: "Contact group",
  EXTSEARCH_USAGE_CONFIRM_DELETE: "Do you really want to delete this item?",
  EXTSEARCH_USAGE_CRITICAL: "{0} of which are approved for dispatch",
  EXTSEARCH_USAGE_DELETION_IMPOSSIBLE: "Deletion disallowed",
  EXTSEARCH_USAGE_DELETION_POSSIBLE: "Confirm deletion",
  EXTSEARCH_USAGE_DETAIL_TT: "Click here to see in which mailings this search is being used.",
  EXTSEARCH_USAGE_LOCK_EXPLANATION: "You may not delete or modify this search because it is used in a mailing which is approved for dispatch.",
  EXTSEARCH_USAGE_LOCK_EXPLANATION_FOLDER: "You may not delete this folder because it contains searches that are used in a mailing which is approved for dispatch.",
  EXTSEARCH_USAGE_PANEL_DESC: "This search is being used in the following mailings:",
  EXTSEARCH_USAGE_PANEL_DESC_FOLDER: "The searches in this folder are being used in the following mailings:",
  EXTSEARCH_USAGE_PANEL_TITLE: "Utilisation in mailings",
  EXTSEARCH_USAGE_TABLE_NAME: "Name",
  EXTSEARCH_USAGE_TABLE_STATUS: "Status",
  EXTSEARCH_USAGE_TOTAL_1: "used in",
  EXTSEARCH_USAGE_TOTAL_2: "{0} mailings",
  FILE_UPLOAD_BUTTON: "Upload",
  FILE_UPLOAD_DESCRIPTION: "Description",
  FILE_UPLOAD_FILE: "File",
  FILE_UPLOAD_TITLE: "File upload",
  GENERIC_APPLY: "Apply",
  GENERIC_BACK: "Back",
  GENERIC_CANCEL: "Cancel",
  GENERIC_CLOSE: "Close",
  GENERIC_COMBO_CHOOSE_VALUE: "[Choose value...]",
  GENERIC_DELETE: "Delete",
  GENERIC_DELETE_ALERT_TITLE: "Confirm deletion",
  GENERIC_DISCARD: "Discard",
  GENERIC_EDIT: "Edit",
  GENERIC_EXPORT: "Export",
  GENERIC_FILTER_CLEAR_TT: "Remove filter",
  GENERIC_FILTER_DESC_TT: "Enter filter expression",
  GENERIC_HINT: "Please note",
  GENERIC_LOADING: "Loading, please stand by...",
  GENERIC_MISSING_RIGHTS: "You do not have the user permissions for this action.",
  GENERIC_MISSING_RIGHTS_DELETE_FOLDER: "You do not have the user permissions to delete elements within this folder.",
  GENERIC_NO: "No",
  GENERIC_NO_SELECTION: "No selection",
  GENERIC_OBJECT_NOT_FOUND_TEXT: "This object could not be loaded. Probably it has been deleted in the meantime.",
  GENERIC_OBJECT_NOT_FOUND_TITLE: "Missing object",
  GENERIC_OK: "Ok",
  GENERIC_ONBEFOREUNLOAD_MESSAGE: "Warning: You are going to exit FairMate CRM.",
  GENERIC_OPEN: "Open",
  GENERIC_QUICKSEARCH_NORESULT: "The quick search did not yield any results. Please change your input.",
  GENERIC_READ_ONLY: "read-only",
  GENERIC_REFRESH: "Refresh",
  GENERIC_SAVE: "Save",
  GENERIC_SAVEAS: "Save as...",
  GENERIC_TEXT_CLEAR_TT: "Clear input",
  GENERIC_UNSAVEABLE_CHANGES: "Do you want to discard your changes?",
  GENERIC_UNSAVED_CHANGES: "Do you want to save your changes?",
  GENERIC_UNSAVED_CHANGES_TITLE: "Unsaved changes",
  GENERIC_YES: "Yes",
  HEADER_ADMIN: "Admin",
  HEADER_DIMEDIS: "dimedis GmbH, Cologne",
  HEADER_HISTORY: "History",
  HEADER_HOME: "Dashboard",
  HEADER_NEW_CONTACT: "New Contact",
  HEADER_QUICKSEARCH_LABEL: "Quick search by name, company, email",
  HEADER_QUICKSEARCH_NO_RESULT: "The quick search did not yield any results. Please try an extended search.",
  HEADER_USERMENU_LOGOUT: "Quit session",
  HEADER_VERSION: "Version",
  HISTORY_LABEL_RESULT: "Search result",
  HOME_ADMINISTRATOR: "Administrator",
  HOME_CHECKBOX_MY_MAILINGS: "My mailings",
  HOME_CHECKBOX_OLD_MAILINGS: "Show old mailings",
  HOME_CHECKBOX_OTHER_MAILINGS: "Other mailings",
  HOME_DATETIME_FORMAT: "DD/MM/YY",
  HOME_LOGOUT: "Exit",
  HOME_MAILINGS_ALL_NOTE: "All mailing will be displayed.",
  HOME_MAILINGS_DISPATCH_NOTE: "Only mailing with a dispatch date will be displayed.",
  HOME_TABLE_CAMPAIGN: "Campaign",
  HOME_TABLE_DATE: "Dispatch date",
  HOME_TABLE_FOLDER: "Folder",
  HOME_TABLE_MAILING: "Mailing",
  HOME_TABLE_PROGRESS: "Status",
  HOME_TABLE_RESPONSIBLE: "Owner",
  HOME_TABLE_SHOW_STATS_TT: "Show mailing statistics",
  HOME_USER: "User",
  LINK_TA_BUTTON_TT: "Add link",
  LINK_TA_POPUP_BTN_OK: "Add link",
  LINK_TA_POPUP_LABEL_LINK: "Link / URL",
  LINK_TA_POPUP_LABEL_TITLE: "Alternative text",
  LINK_TA_POPUP_TITLE: "Add link",
  LOCALE_CAMPAIGN_AXIS_DAY: "DD.MM.YYYY",
  LOCALE_CAMPAIGN_AXIS_DAY_CHART: "DD MMM",
  LOCALE_CAMPAIGN_AXIS_MONTH: "MM.YYYY",
  LOCALE_CAMPAIGN_AXIS_MONTH_CHART: "MM YYYY",
  LOCALE_CAMPAIGN_AXIS_YEAR: "YYYY",
  LOCALE_DATETIME_FORMAT: "DD/MM/YY hh:mm:ss A",
  LOCALE_DATETIME_FORMAT_SHORT: "DD/MM/YYYY HH:mm",
  LOCALE_DATE_FORMAT: "DD/MM/YYYY",
  LOCALE_DATE_RANGE_FORMAT: "dd/MM/yyyy",
  LOCALE_MONTH_APR: "April",
  LOCALE_MONTH_AUG: "August",
  LOCALE_MONTH_DEC: "December",
  LOCALE_MONTH_FEB: "February",
  LOCALE_MONTH_JAN: "January",
  LOCALE_MONTH_JUL: "July",
  LOCALE_MONTH_JUN: "June",
  LOCALE_MONTH_MAR: "March",
  LOCALE_MONTH_MAY: "May",
  LOCALE_MONTH_NOV: "November",
  LOCALE_MONTH_OCT: "October",
  LOCALE_MONTH_SEP: "September",
  LOCALE_THOUSANDS_SEPARATOR: ",",
  LOCALE_TIME_FORMAT_SHORT: "HH:mm",
  LOCALE_WEEKDAY_ABBR_FRI: "Fr",
  LOCALE_WEEKDAY_ABBR_MON: "Mo",
  LOCALE_WEEKDAY_ABBR_SAT: "Sa",
  LOCALE_WEEKDAY_ABBR_SUN: "Su",
  LOCALE_WEEKDAY_ABBR_THU: "Th",
  LOCALE_WEEKDAY_ABBR_TUE: "Tu",
  LOCALE_WEEKDAY_ABBR_WED: "We",
  LOGIN_FAILED: "Login failed. Please check user name and password.",
  LOGIN_HEADER: "Login",
  LOGIN_LOGIN: "Log in",
  LOGIN_NOACCESS: "This user account has no access permissions for the FairMate CRM.",
  LOGIN_PASSWORD: "Password",
  LOGIN_SESSION_EXPIRED: "Your Session has expired. Please log in again.",
  LOGIN_USERNAME: "User name",
  MAILING: "Mailing",
  MAILING_EMAIL_PLACEHOLDER: "\"Your Name\" <your@domain.com>",
  MAILING_APPROVE: "Approve for dispatch",
  MAILING_CHOOSE_TEMPLATE: "Choose",
  MAILING_CHOOSE_TEMPLATE_TT: "Choose different mailing template",
  MAILING_CHOOSE_UNSUBSCRIBE_TT: "Choose different unsubscribe link",
  MAILING_CLEAR_TIME_TT: "Clear dispatch time",
  MAILING_COUNT_RECIPIENTS_ALL_TT: "All email addresses, incl. duplicates",
  MAILING_COUNT_RECIPIENTS_TT: "Count recipients",
  MAILING_COUNT_RECIPIENTS_UNIQUE_TT: "Unique email addresses, excl. duplicates",
  MAILING_DATE: "Date",
  MAILING_DELETE: "Delete",
  MAILING_DELETE_ALERT: "Do you really want to delete this mailing?",
  MAILING_DELETE_FOLDER_ALERT: "This folder cannot be deleted because it contains mailings which are approved for dispatch.",
  MAILING_DELETE_RELEASED_ALERT: "This mailing has been scheduled for dispatch. Before deleting it you must first revoke the approval.",
  MAILING_DELETE_SENDING_ALERT: "This mailing is currently being dispatched. It cannot be deleted.",
  MAILING_DISPATCH_DATE: "Dispatch Date",
  MAILING_DISPATCH_PAST: "The dispatch time must not be in the past.",
  MAILING_DISPATCH_PAST_CONFIRM: "The time selected for dispatch is in the past. Do you still want to continue dispatch?",
  MAILING_DISPATCH_PAST_CONFIRM_YES: "Yes, continue dispatch.",
  MAILING_DISPATCH_PAST_CONFIRM_NO: "No, cancel dispatch and change the date and time.",
  MAILING_DISPATCH_TIME: "Dispatch Time",
  MAILING_EDIT_TEMPLATE_TT: "Edit mailing template in @it",
  MAILING_EDIT_UNSUBSCRIBE_TT: "Edit unsubscribe Link in @it",
  MAILING_FROM: "From",
  MAILING_LANGUAGE: "Language",
  MAILING_MAIN_DATA: "Mailing Data",
  MAILING_ENTER_NAME: "Please enter a name for this mailing.",
  MAILING_ENTER_NAME_TITLE: "Missing name",
  MAILING_MISSING_DISPATCH: "The dispatch time must be populated.",
  MAILING_MISSING_EMAIL_DISPLAYNAME: "The sender address in 'From' is invalid. The correct format for an email address with a display name is: \nJohn Smith <jsmith@example.com>",
  MAILING_MISSING_EMAIL_INVALID: "The sender address in 'From' must be a valid email address. Example: jsmith@example.com",
  MAILING_MISSING_FIELDS: "This mailing cannot be approved, because mandatory information is missing.",
  MAILING_MISSING_FIELDS_TITLE: "Invalid mailing",
  MAILING_MISSING_OFFLINE: "The mailing template is not online in @it.",
  MAILING_MISSING_RECIPIENTS: "No recipients are selected.",
  MAILING_MISSING_SENDER: "The 'From' field must be populated.",
  MAILING_MISSING_SUBJECT: "The 'Subject' field must be populated.",
  MAILING_MISSING_TEMPLATE: "A mailing template must be selected.",
  MAILING_NAME: "Name",
  MAILING_NOT_SAVED: "Please save the mailing first.",
  MAILING_OWNER: "Owner",
  MAILING_PREVIEW_HTML: "HTML preview",
  MAILING_PREVIEW_HTML_TT: "View HTML version of mailing in new window",
  MAILING_PREVIEW_TEXT: "Text preview",
  MAILING_PREVIEW_TEXT_TT: "View text version of mailing in new window",
  MAILING_RECIPIENTS: "Recipients",
  MAILING_RECIPIENTS_DRAG_HERE: "Insert searches via drag&drop from main navigation.",
  MAILING_RECIPIENTS_SEARCH: "Start typing Search or Group name",
  MAILING_REMOVE_RECIPIENT_TT: "Remove selected entry",
  MAILING_RESET_ALERT: "Do you really want to reset the configuration of this mailing?",
  MAILING_REVOKE: "Revoke approval",
  MAILING_SAVE: "Save",
  MAILING_SAVEAS_HEADER: "Save mailing",
  MAILING_SAVE_AS: "Save as...",
  MAILING_SEND_NOW: "Now!",
  MAILING_SEND_NOW_TT: "Set dispatch time to current time",
  MAILING_SEND_ONCE: "Send only once for duplicate email addresses",
  MAILING_STATUS: "Status",
  MAILING_STATUS_CLOSED: "closed",
  MAILING_STATUS_CLOSED_COUNT: "emails sent: {0}",
  MAILING_STATUS_OPEN: "open",
  MAILING_STATUS_RELEASED: "approved",
  MAILING_STATUS_RELEASED_IMMEDIATE: "Waiting for dispatch...",
  MAILING_STATUS_RELEASED_SCHEDULED_AT: "Dispatch at {0}",
  MAILING_STATUS_RELEASED_SCHEDULED_DAYS: "Dispatch in {0} days",
  MAILING_STATUS_RELEASED_SCHEDULED_HOUR: "Dispatch in < 1 hour",
  MAILING_STATUS_RELEASED_SCHEDULED_HOURS: "Dispatch in {0} hours",
  MAILING_STATUS_RELEASED_SCHEDULED_MONTH: "Dispatch in > 1 month",
  MAILING_STATUS_SENDING: "sending",
  MAILING_STATUS_SENDING_STARTED: "Dispatch started!",
  MAILING_SUBJECT: "Subject",
  MAILING_TEMPLATE: "Template",
  MAILING_TEMPLATE_GUIDE_BUTTON: "Placeholder Help",
  MAILING_TESTMAIL_BUTTON: "Test dispatch...",
  MAILING_TIME: "Time",
  MAILING_UNSUBSCRIBE: "Unsubscribe link",
  MAILING_VIEW_RECIPIENTS_CM: "Show recipients",
  MAILING_VIEW_STATISTICS: "Statistics",
  MASSEDIT_ACTION_CLEAR: "clear",
  MASSEDIT_ACTION_DESELECT: "deselect",
  MASSEDIT_ACTION_SELECT: "select",
  MASSEDIT_ACTION_SETTEXT: "replace with",
  MASSEDIT_ALERT_TEXT: "This mass edit configuration contains invalid commands. Please double-check your settings.",
  MASSEDIT_ALERT_TITLE: "Invalid command",
  MASSEDIT_FOOTER: "Note: By setting new values the displayed search results may change. Your marks will be removed after applying the changes.",
  MASSEDIT_NUMBER_CONTACTS: "Selected contacts:",
  MASSEDIT_NUMBER_INCLUDED: "Number of included contacts: {0}",
  MASSEDIT_PROMPT_CHOOSE_ACTION: "[Choose command...]",
  MASSEDIT_PROMPT_CHOOSE_FIELD: "[Choose field...]",
  MASSEDIT_PROMPT_CHOOSE_VALUE: "[Choose value...]",
  MASSEDIT_RUN: "Apply changes",
  MASSEDIT_TITLE: "Mass edit",
  MERGE_ADDRESS_BUTTON_EXECUTE: "Apply result address",
  MERGE_ADDRESS_BUTTON_MASTER: "Select all fields",
  MERGE_ADDRESS_INFO_TEXT: "Select the best address by clicking on the crown. Additionally you can select individual fields from other columns in order to improve data quality. Once you are satisfied with the merge result, click 'Apply result address'.",
  MERGE_ADDRESS_NOADDRESSES_TEXT: "No addresses could be found for company '{0}'.",
  MERGE_ADDRESS_NOADDRESSES_TITLE: "No data found",
  MERGE_ADDRESS_PANEL_TITLE: "Pick company address",
  MERGE_ALERT_TITLE: "Merge",
  MERGE_ATLEASTTWO_ALERT: "You have to select at least 2 contacts on this page to start a merge process.",
  MERGE_BOUNCED_TT: "email address is flagged as 'bounced'",
  MERGE_BUTTON_EXCLUDE: "Exclude",
  MERGE_BUTTON_EXECUTE: "Merge contacts",
  MERGE_BUTTON_MASTER: "Master",
  MERGE_LAST_LOGIN_TT: "Last login with this account (public)",
  MERGE_MAXCONTACTS_ALERT: "You can't include more than {0} contacts in a merge process.",
  MERGE_MINIMUM_TEXT: "You have excluded too many contacts. At least 2 columns must be active in order to proceed with the merging.",
  MERGE_MINIMUM_TITLE: "Warning: Merge not possible",
  MERGE_MULTICAT_INTRO: "Merge multiple-selection categories...",
  MERGE_MULTICAT_JOIN: "... by joining the settings of all contacts",
  MERGE_MULTICAT_MASTER: "... by copying only the master contact's settings",
  MERGE_NO_ACCOUNT: "[no account]",
  MERGE_NO_LOGIN: "[no login recorded]",
  MERGE_NUMBER_INCLUDED: "Number of included contacts: {0}",
  MERGE_PANEL_TITLE: "Contact merge",
  MERGE_RESULT_TITLE: "Merge result",
  MERGE_STEP1_TEXT: "You should select the contact with the best data quality as master contact. During the merge process you can enhance the master with data from the other contacts. After the merge process all included contacts except for the master will be deleted.",
  MERGE_STEP1_TITLE: "Step 1: Select master",
  MERGE_STEP2_TEXT: "You can exclude a contact from the merge process via the 'Exclude' button. An excluded contact will not modified or deleted during the merge process. In order to enhance the data quality of the master, you can click on a cell in one of the other columns. The clicked value will be written to the merge result.",
  MERGE_STEP2_TITLE: "Step 2: Exclude and enhance",
  NAVI_CONFIRM_DELETE_MAILING: "Do you really want to delete mailing '{0}'?",
  NAVI_CONFIRM_DELETE_PRINTMAIL: "Do you really want to delete print mailing '{0}'?",
  NAVI_CONFIRM_DELETE_SEARCH: "Do you really want to delete saved search '{0}'?",
  NAVI_DELETE_CAMPAIGN_CM: "Delete campaign",
  NAVI_DELETE_FOLDER_CM: "Delete folder",
  NAVI_DELETE_GROUP_CM: "Delete group",
  NAVI_DELETE_MAILING_CM: "Delete mailing",
  NAVI_DELETE_PRINTMAIL_CM: "Delete print mailing",
  NAVI_DELETE_SEARCH_CM: "Delete search",
  NAVI_EDIT_CAMPAIGN_CM: "Edit campaign",
  NAVI_EDIT_GROUP_CM: "Edit group",
  NAVI_EDIT_MAILING_CM: "Edit mailing",
  NAVI_EDIT_PRINTMAIL_CM: "Edit print mailing",
  NAVI_EDIT_SEARCH_CM: "Edit search",
  NAVI_EXECUTE_GROUP_CM: "Show group",
  NAVI_EXECUTE_SEARCH_CM: "Run search",
  NAVI_FOLDER_READONLY_MAILINGS: "This object cannot be deleted because it contains mailings of other users.",
  NAVI_FOLDER_WITH_CHILDREN: "All items in this folder will be deleted as well.\nDo you want to continue?",
  NAVI_MAILINGS_TITLE: "Campaigns",
  NAVI_MAILINGS_NO_RESULTS: "No data found",
  NAVI_NEW_CAMPAIGN_CM: "New campaign",
  NAVI_NEW_CAMPAIGN_TT: "Create new campaign",// at root level",
  NAVI_NEW_FOLDER_CM: "New folder",
  NAVI_NEW_FOLDER_TT: "Create new folder",// at root level",
  NAVI_NEW_GROUP_CM: "New group",
  NAVI_NEW_GROUP_TT: "Create new contact group",// at root level",
  NAVI_NEW_MAILING_CM: "New mailing",
  NAVI_NEW_MAILING_TT: "Create new mailing",// at root level",
  NAVI_NEW_PRINTMAIL_CM: "New print mailing",
  NAVI_NEW_SEARCH_CM: "New search",
  NAVI_NEW_SEARCH_TT: "Create new search",// at root level",
  NAVI_NODROP_CAMPAIGN: "A campaign cannot have subcampaigns",
  NAVI_NODROP_NOT_OWNER: "You cannot move this object because you are not its owner",
  NAVI_NODROP_READONLY_FOLDER: "You have no write access to the target folder",
  NAVI_NODROP_SUBFOLDER: "A folder cannot be moved into its own subfolder",
  NAVI_NODROP_WRONG_TREE: "Objects can only be dragged within their own tree",
  NAVI_OVERLAY_HEAD_NEW_FOLDER: "New folder",
  NAVI_OVERLAY_HEAD_CREATE: "Create",
  NAVI_OVERLAY_HEAD_RENAME: "Rename",
  NAVI_OVERLAY_HEAD_RENAME_FOLDER: "Rename folder",
  NAVI_OVERLAY_HEAD_RENAME_GROUP: "Rename group",
  NAVI_OVERLAY_HEAD_RENAME_SEARCH: "Rename search",
  NAVI_OVERLAY_HEAD_RENAME_CAMPAIGN: "Rename campaign",
  NAVI_OVERLAY_HEAD_RENAME_MAILING: "Rename mailing",
  NAVI_READONLY_CAMPAIGN_CM: "Open campaign",
  NAVI_READONLY_GROUP_CM: "Open contact group",
  NAVI_READONLY_MAILING_CM: "Open mailing",
  NAVI_READONLY_PRINTMAIL_CM: "Open print mailing",
  NAVI_READONLY_SEARCH_CM: "Open search",
  NAVI_REFRESH_NAVI_CM: "Refresh menu",
  NAVI_RENAME_FOLDER_CM: "Rename folder",
  NAVI_RENAME_GROUP_CM: "Rename group",
  NAVI_RENAME_MAILING_CM: "Rename mailing",
  NAVI_RENAME_PRINTMAIL_CM: "Rename print mailing",
  NAVI_RENAME_SEARCH_CM: "Rename search",
  NAVI_SEARCHES_TITLE: "Saved Searches",
  NAVI_SEARCHES_NO_RESULTS: "No data found",
  NAVI_SHOW_ALL_CONTACTS_CM: "Show all contacts",
  NAVI_TOMAILING_GROUP_CM: "Add group to mailing",
  NAVI_TOMAILING_SEARCH_CM: "Add search to mailing",
  PROCESSING_POPUP_CONTENT: "A long running process has been started. Please wait.",
  PROCESSING_POPUP_TITLE: "Processing...",
  REPORTING_BUTTON_HIDE_VALUES: "Show/hide values",
  REPORTING_BUTTON_WHERE_EXTSEARCH: "By search",
  REPORTING_BUTTON_WHERE_EXTSEARCH_TT: "Define person filter via a saved search or contact group.",
  REPORTING_BUTTON_WHERE_MANUAL: "Manual",
  REPORTING_BUTTON_WHERE_MANUAL_TT: "Define person filter criteria manually.",
  REPORTING_CB_ALL_PERSONS: "[All persons]",
  REPORTING_CB_NO_CATEGORY: "[No category]",
  REPORTING_DOWNLOAD_CHART_CM: "Save chart image as...",
  REPORTING_DOWNLOAD_EXCEL_CM: "Export data to Excel...",
  REPORTING_HEADING_GROUP: "grouped by",
  REPORTING_HEADING_WHERE: "Person filter",
  REPORTING_HINT_SAVED_SEARCH: "Drag a saved search or contact group from the left-hand navigation column into the field below.",
  REPORTING_LABEL_ALL: "[all]",
  REPORTING_LABEL_UNGROUPED: "[without category]",
  REPORTING_NUM_EXCLUDED: "... of which not in chart",
  REPORTING_NUM_EXCLUDED_TT: "Sum of assigned categories which are either\na) manually hidden via 'Show/hide values', or\nb) summed up in the 'Other' column while that column is deactivated via 'Options'",
  REPORTING_NUM_GROUPED: "Total assigned categories",
  REPORTING_NUM_GROUPED_TT: "Sum of all assigned categories from the selected grouping. A person is counted multiple times if it has multiple values of that grouping assigned to it.",
  REPORTING_NUM_UNGROUPED: "Persons without category",
  REPORTING_NUM_UNGROUPED_TT: "Number of all persons which do not have any value assigned from the selected grouping.",
  REPORTING_OPTIONS: "Options",
  REPORTING_OPTIONS_DATA_LABELS: "Show data labels",
  REPORTING_OPTIONS_OTHER: "Others",
  REPORTING_OPTIONS_SHOW_MAX_1: "Show",
  REPORTING_OPTIONS_SHOW_MAX_2: "values maximum",
  REPORTING_OPTIONS_SORT_BYVALUE: "by value",
  REPORTING_OPTIONS_SORT_ALPHA_ALLVALUES: "alphabetical",
  REPORTING_OPTIONS_SORT_ALPHA_TOPVALUES: "by value and alphabetical",
  REPORTING_OPTIONS_SORT_TITLE: "Sort",
  REPORTING_OPTIONS_VIEW_TITLE: "Display",
  REPORTING_OPTIONS_SUM_OTHER: "Sum up others",
  REPORTING_SAVED_BTN_LOAD: "Load",
  REPORTING_SAVED_BTN_UPDATE: "Overwrite",
  REPORTING_SAVED_DELETE_ALERT: "Do you really want to delete this saved report?",
  REPORTING_SAVED_DEMO_TITLE: "Demo: Top 10 Non-EU Countries",
  REPORTING_SAVED_HINT_EXISTING: "The selected report will be overwritten with the current settings. Alternatively you can change the name in order to create a new report.",
  REPORTING_SAVED_HINT_NEW2: "Alternatively you can select an existing report from the list above in order to overwrite it.",
  REPORTING_SAVED_HINT_NEW: "A new report will be saved under this name.",
  REPORTING_SAVED_NO_REPORTS: "No saved reports",
  REPORTING_SAVED_SECTION_LOAD: "Load report",
  REPORTING_SAVED_SECTION_SAVE: "Save report as...",
  REPORTING_SAVED_TITLE: "Load / save report",
  REPORTING_TITLE_ALL_PERSONS: "All persons",
  REPORTING_TITLE_GROUPED_BY: "grouped by",
  REPORTING_TITLE_PERSONS_WITH: "Persons",
  REPORTING_TYPE_BARCHART: "Bar chart",
  REPORTING_TYPE_COLUMNCHART: "Column chart",
  REPORTING_TYPE_PIECHART: "Pie chart",
  REPORTING_WARN_UNKNOWN_CATEGORIES: "One ore more category lists used in this report do not exist any more. The respective settings have been discarded.",
  REPORTING_WARN_UNKNOWN_QUERY: "The saved search used in this report does not exist any more. Consequently the person filter has been cleared.",
  RESUBMISSION_DELETE_ALERT: "Do you really want to delete this resubmission?\n\nNote: The entry will be deleted entirely, including comment. If you only wish to deactivate this resubmission, please use the 'Done' checkbox of the entry.",
  RESUBMISSION_TITLE: "Resubmission",
  RESULTS_ALL_CONTACTS: "All contacts",
  RESULTS_BACK_TO_CONTACT: "Back to contact panel",
  RESULTS_BACK_TO_COUNTRYFIX: "Back to Country correction",
  RESULTS_BACK_TO_GROUP: "Back to group screen",
  RESULTS_BACK_TO_MAILING: "Back to mailing",
  RESULTS_BACK_TO_REPORT: "Back to report",
  RESULTS_BACK_TO_SEARCH: "Back to search screen",
  RESULTS_COLUMN_NO_EDIT_NO_SORT_TT: "This field cannot be sorted or edited.",
  RESULTS_COLUMN_NO_EDIT_TT: "This field cannot be edited.",
  RESULTS_COLUMN_NO_SORT_TT: "This field cannot be sorted.",
  RESULTS_CONFIRM_MULTI_DELETE: "{0} contacts will be permanently deleted from the database. Do you want to continue?",
  RESULTS_CONTACTGROUP_PANEL_ALERT_COMBOBOX_TITLE: "No selection",
  RESULTS_CONTACTGROUP_PANEL_ALERT_COMBOBOX_TXT: "Please choose a contact group.",
  RESULTS_CONTACTGROUP_PANEL_ALERT_TEXTFIELD_TITLE: "Name missing",
  RESULTS_CONTACTGROUP_PANEL_ALERT_TEXTFIELD_TXT: "Please type in a name for the new contact group.",
  RESULTS_CONTACTGROUP_PANEL_BT_TOGROUP: "Add",
  RESULTS_CONTACTGROUP_PANEL_TITLE: "Add to group",
  RESULTS_CONTACTGROUP_PANEL_TXT_AMOUNT: "Selected contacts:",
  RESULTS_CONTACTGROUP_PANEL_TXT_NEWGROUP: "Add to new contact group",
  RESULTS_CONTACTGROUP_PANEL_TXT_TOGROUP: "Add to existing group",
  RESULTS_CONTACTS: "Contacts",
  RESULTS_COUNTRYFIX_HEADER: "Contacts with invalid country",
  RESULTS_CREATE_NEW_CONTACTGROUP_CM: "Add selected contacts to group",
  RESULTS_DELETE_CONTACT_CM: "Delete contact",
  RESULTS_DEL_MARKED_CONTACTS_CM: "Delete selected contacts",
  RESULTS_EDIT_CELL_CM: "Edit cell",
  RESULTS_EDIT_GROUP: "Edit group",
  RESULTS_EDIT_MARKED_CONTACTS_CM: "Edit selected contacts",
  RESULTS_EDIT_SEARCH: "Edit search",
  RESULTS_EMPLOYEES: "Employees of company",
  RESULTS_EXPORT_MARKED_CONTACTS_CM: "Export selected contacts",
  RESULTS_EXT_SEARCH: "Extended search",
  RESULTS_FIELD_COUNTRY_NAME: "Country Name",
  RESULTS_FREEFIELD_COLUMN_TT: "Custom fields cannot be sorted or edited.",
  RESULTS_GROUP: "Contact group",
  RESULTS_IN_SEARCH_FIELDS: "in last name, first name, company",
  RESULTS_MARK_ALL_CM: "Mark all",
  RESULTS_MARK_INVERT_CM: "Invert marks",
  RESULTS_MARK_NONE_CM: "Mark none",
  RESULTS_MERGE_MARKED_CONTACTS_CM: "Merge marked contacts",
  RESULTS_NAVI_DELETE: "Delete",
  RESULTS_NAVI_EDIT: "Edit",
  RESULTS_NAVI_EXPORT: "Export",
  RESULTS_NAVI_GROUP: "Group",
  RESULTS_NAVI_MERGE: "Merge",
  RESULTS_NAVI_OPEN: "Open",
  RESULTS_NEW_EXT_SEARCH: "Unnamed extended search",
  RESULTS_NEW_GROUP: "Unnamed contact group",
  RESULTS_NO_RESULTS: "No results found.",
  RESULTS_NO_SELECTION: "No contacts are selected.",
  RESULTS_NO_SELECTION_TITLE: "No selection",
  RESULTS_NUM_SELECTED: "Selected contacts: {0}",
  RESULTS_OPEN_CONTACT_CM: "Open contact",
  RESULTS_PER_PAGE: "Results per page",
  RESULTS_RANGE: "{0} to {1} of {2} results",
  RESULTS_RECIPIENTS: "Recipients",
  RESULTS_REFRESH_CHECKBOX: "Refresh search results automatically",
  RESULTS_REFRESH_DESCRIPTION: "If this option is deactivated, the search result will not be automatically refreshed when contacts are modified.",
  RESULTS_REFRESH_RECOMMENDED_DISABLED_TT: "Automatic refresh is disabled. The search result is possibly not up-to-date.",
  RESULTS_REFRESH_RECOMMENDED_TT: "The search result is possibly not up-to-date.",
  RESULTS_REFRESH_TITLE: "Automatic refresh",
  RESULTS_REPORT_DRILLDOWN_HEADER: "Report drill-down",
  RESULTS_SEARCH_NOT_SAVED: "(not saved)",
  RESULTS_SELECT_COLUMNS: "Select columns",
  RESULTS_SELECT_COLUMNS_APPLY: "Apply",
  RESULTS_SELECT_COLUMNS_VISIBLE: "Visible columns",
  RESULTS_SELECT_DEFAULT: "Default settings",
  RESULTS_SETTINGS: "Settings",
  RESULTS_SIMPLE_SEARCH: "Simple search",
  RESULTS_SIMPLE_SEARCH_FOR: "Simple search for",
  RESULTS_TOMANY_SELECTION: "You have selected too many contacts. Please select no more than {0} contacts.",
  RESULTS_TOMANY_SELECTION_TITLE: "Too many contacts",
  RIGHTSPANEL_BT_SAVE_OTHERS: "({0} users selected)",
  RIGHTSPANEL_CURRENT_CHANGED_ALERT: "You have changed the permissions of the currently logged-in user. Some settings may not be applied until your next login to the CRM.",
  RIGHTSPANEL_LOAD_UNSAVED_ALERT_TEXT: "Your unsaved changes to the permissions configuration will be discarded when you load a configuration. Do you want to discard the current configuration?",
  RIGHTSPANEL_RIGHTS_LOAD: "Load configuration (optional)",
  RIGHTSPANEL_RIGHTS_LOAD_PRESET: "from default presets",
  RIGHTSPANEL_RIGHTS_LOAD_PRESET_POPUP: "Select preset",
  RIGHTSPANEL_RIGHTS_LOAD_USER: "from user",
  RIGHTSPANEL_RIGHTS_LOAD_USER_POPUP: "Select user",
  RIGHTSPANEL_RIGHTS_NUM: "({0} of {1} permissions selected)",
  RIGHTSPANEL_RIGHTS_SAVE_SUBTITLE: "for these users",
  RIGHTSPANEL_RIGHTS_SAVE_TITLE: "Save configuration",
  RIGHTSPANEL_RIGHTS_SELECTED: "Permissions configuration",
  RIGHTSPANEL_RIGHTS_SELECTED_HINT: "(Click in list to edit)",
  RIGHTSPANEL_SAVE_OTHERS_ALERT: "Do you want to apply these permissions to {0} users?",
  RIGHTSPANEL_SAVE_OTHERS_ALERT_TITLE: "Confirm permissions",
  RIGHTSPANEL_TITLE: "Configure permissions",
  RIGHTSPANEL_USERLIST_ALERT_BTN_KEEP: "Keep",
  RIGHTSPANEL_USERLIST_ALERT_TEXT: "You have selected multiple users under 'Save configuration'. Do you want to discard this selection or keep it?",
  RIGHTSPANEL_USERLIST_ALERT_TITLE: "Selected users",
  RIGHTSPANEL_USER_ADMIN_TT: "This user is an administrator",
  RIGHT_GROUP_CAMPAIGN_DESC: "",
  RIGHT_GROUP_CAMPAIGN_NAME: "Campaigns",
  RIGHT_GROUP_CAMPAIGN_TREE_DESC: "",
  RIGHT_GROUP_CAMPAIGN_TREE_NAME: "Campaigns menu",
  RIGHT_GROUP_CONTACT_DESC: "",
  RIGHT_GROUP_CONTACT_NAME: "Contacts",
  RIGHT_GROUP_DASHBOARD_DESC: "",
  RIGHT_GROUP_DASHBOARD_NAME: "Dashboard",
  RIGHT_GROUP_MAILING_DESC: "",
  RIGHT_GROUP_MAILING_NAME: "Mailings",
  RIGHT_GROUP_MULTI_DESC: "",
  RIGHT_GROUP_MULTI_NAME: "Mass data",
  RIGHT_GROUP_NOTE_DESC: "",
  RIGHT_GROUP_NOTE_NAME: "Contact notes",
  RIGHT_GROUP_OTHER_DESC: "",
  RIGHT_GROUP_OTHER_NAME: "Admin",
  RIGHT_GROUP_PRINT_MAIL_DESC: "",
  RIGHT_GROUP_PRINT_MAIL_NAME: "Print Mailings",
  RIGHT_GROUP_RESUBMISSION_DESC: "",
  RIGHT_GROUP_RESUBMISSION_NAME: "Resubmissions",
  RIGHT_GROUP_SEARCH_DESC: "",
  RIGHT_GROUP_SEARCH_NAME: "Searches and contact groups",
  RIGHT_GROUP_SEARCH_TREE_DESC: "",
  RIGHT_GROUP_SEARCH_TREE_NAME: "People menu",
  RIGHT_PRESET_ALL: "Full access",
  RIGHT_PRESET_ANALYSIS: "Analysis",
  RIGHT_PRESET_DATAENTRY: "Data entry",
  RIGHT_PRESET_NONE: "Minimum access",
  RIGHT_VAR_ADMIN_CONTACT_EDIT_DESC: "",
  RIGHT_VAR_ADMIN_CONTACT_EDIT_NAME: "Admin: Edit contact tabs",
  RIGHT_VAR_ADMIN_COUNTRYFIX_EDIT_DESC: "",
  RIGHT_VAR_ADMIN_COUNTRYFIX_EDIT_NAME: "Admin: Country correction",
  RIGHT_VAR_ADMIN_EDIT_LOAD_DESC: "",
  RIGHT_VAR_ADMIN_EDIT_LOAD_NAME: "Admin: @it functions",
  RIGHT_VAR_CAMPAIGN_CREATE_DESC: "",
  RIGHT_VAR_CAMPAIGN_CREATE_NAME: "Campaigns: Create new",
  RIGHT_VAR_CAMPAIGN_DELETE_DESC: "",
  RIGHT_VAR_CAMPAIGN_DELETE_NAME: "Campaigns: Delete",
  RIGHT_VAR_CAMPAIGN_EDIT_DESC: "",
  RIGHT_VAR_CAMPAIGN_EDIT_NAME: "Campaigns: Edit",
  RIGHT_VAR_CAMPAIGN_TOP_LEVEL_CREATE_DESC: "requires 'Campaigns: Create new'",
  RIGHT_VAR_CAMPAIGN_TOP_LEVEL_CREATE_NAME: "Campaigns: Create new at root level",
  RIGHT_VAR_CAMPAIGN_TREE_SEE_DESC: "Displays the campaigns menu. The permissions for individual object types in that menu must be defined separately. ",
  RIGHT_VAR_CAMPAIGN_TREE_SEE_NAME: "Campaigns menu: Show menu",
  RIGHT_VAR_CATEGORY_CREATE_DESC: "",
  RIGHT_VAR_CATEGORY_CREATE_NAME: "Categories: Add new categories",
  RIGHT_VAR_CONTACT_CREATE_DESC: "",
  RIGHT_VAR_CONTACT_CREATE_NAME: "Contacts: Create new",
  RIGHT_VAR_CONTACT_DELETE_DESC: "",
  RIGHT_VAR_CONTACT_DELETE_NAME: "Contacts: Delete",
  RIGHT_VAR_CONTACT_EDIT_DESC: "",
  RIGHT_VAR_CONTACT_EDIT_NAME: "Contacts: Edit",
  RIGHT_VAR_DASHBOARD_CAMPAIGN_SEE_DESC: "",
  RIGHT_VAR_DASHBOARD_CAMPAIGN_SEE_NAME: "Dashboard: Show 'Campaigns'",
  RIGHT_VAR_DASHBOARD_MAILING_SEE_DESC: "",
  RIGHT_VAR_DASHBOARD_MAILING_SEE_NAME: "Dashboard: Show 'Mailings'",
  RIGHT_VAR_DASHBOARD_REPORTING_SEE_DESC: "",
  RIGHT_VAR_DASHBOARD_REPORTING_SEE_NAME: "Dashboard: Show 'Reporting'",
  RIGHT_VAR_FOLDER_CAMPAIGN_CREATE_DESC: "",
  RIGHT_VAR_FOLDER_CAMPAIGN_CREATE_NAME: "Campaigns menu: Create new folder",
  RIGHT_VAR_FOLDER_CAMPAIGN_DELETE_DESC: "",
  RIGHT_VAR_FOLDER_CAMPAIGN_DELETE_NAME: "Campaigns menu: Delete folder ",
  RIGHT_VAR_FOLDER_CAMPAIGN_EDIT_DESC: "",
  RIGHT_VAR_FOLDER_CAMPAIGN_EDIT_NAME: "Campaigns menu: Edit folder",
  RIGHT_VAR_FOLDER_CAMPAIGN_TOP_LEVEL_CREATE_DESC: "requires 'Campaigns menu: Create new folder'",
  RIGHT_VAR_FOLDER_CAMPAIGN_TOP_LEVEL_CREATE_NAME: "Campaigns menu: Create new folder at root level",
  RIGHT_VAR_FOLDER_SEARCH_CREATE_DESC: "",
  RIGHT_VAR_FOLDER_SEARCH_CREATE_NAME: "People menu: Create new folder",
  RIGHT_VAR_FOLDER_SEARCH_DELETE_DESC: "",
  RIGHT_VAR_FOLDER_SEARCH_DELETE_NAME: "People menu: Delete folder",
  RIGHT_VAR_FOLDER_SEARCH_EDIT_DESC: "",
  RIGHT_VAR_FOLDER_SEARCH_EDIT_NAME: "People menu: Edit folder",
  RIGHT_VAR_MAILING_APPROVE_DESC: "",
  RIGHT_VAR_MAILING_APPROVE_NAME: "Mailings: Approve for dispatch",
  RIGHT_VAR_MAILING_CREATE_DESC: "",
  RIGHT_VAR_MAILING_CREATE_NAME: "Mailings: Create new",
  RIGHT_VAR_MAILING_DELETE_DESC: "",
  RIGHT_VAR_MAILING_DELETE_NAME: "Mailings: Delete",
  RIGHT_VAR_MAILING_EDIT_DESC: "",
  RIGHT_VAR_MAILING_EDIT_NAME: "Mailings: Edit",
  RIGHT_VAR_MAILING_PREVIEW_SEE_DESC: "",
  RIGHT_VAR_MAILING_PREVIEW_SEE_NAME: "Mailings: Test dispatch",
  RIGHT_VAR_MAILING_REVOKE_DESC: "",
  RIGHT_VAR_MAILING_REVOKE_NAME: "Mailings: Revoke approval",
  RIGHT_VAR_MAILING_STATISTICS_SEE_DESC: "",
  RIGHT_VAR_MAILING_STATISTICS_SEE_NAME: "Mailings: Statistics",
  RIGHT_VAR_MAILING_TOP_LEVEL_CREATE_DESC: "requires 'Mailings: Create new'",
  RIGHT_VAR_MAILING_TOP_LEVEL_CREATE_NAME: "Mailings: Create new at root level",
  RIGHT_VAR_MULTI_DELETE_DESC: "requires 'Contacts: Delete'",
  RIGHT_VAR_MULTI_DELETE_NAME: "Mass data: Delete contacts",
  RIGHT_VAR_MULTI_EDIT_DESC: "requires 'Contacts: Edit'",
  RIGHT_VAR_MULTI_EDIT_NAME: "Mass data: Edit contacts",
  RIGHT_VAR_MULTI_EXPORT_DESC: "",
  RIGHT_VAR_MULTI_EXPORT_NAME: "Mass data: Export contacts",
  RIGHT_VAR_MULTI_MERGE_DESC: "requires 'Mass data: Edit contacts' and 'Mass data: Delete contacts'",
  RIGHT_VAR_MULTI_MERGE_NAME: "Mass data: Merge contacts",
  RIGHT_VAR_NOTE_CREATE_DESC: "",
  RIGHT_VAR_NOTE_CREATE_NAME: "Contact notes: Create new",
  RIGHT_VAR_NOTE_EDIT_DESC: "",
  RIGHT_VAR_NOTE_EDIT_NAME: "Contact notes: Edit",
  RIGHT_VAR_PRINT_MAIL_CREATE_DESC: "",
  RIGHT_VAR_PRINT_MAIL_CREATE_NAME: "Print Mailings: Create new",
  RIGHT_VAR_PRINT_MAIL_DELETE_DESC: "",
  RIGHT_VAR_PRINT_MAIL_DELETE_NAME: "Print Mailings: Delete",
  RIGHT_VAR_PRINT_MAIL_EDIT_DESC: "",
  RIGHT_VAR_PRINT_MAIL_EDIT_NAME: "Print Mailings: Edit",
  RIGHT_VAR_PRINT_MAIL_TOP_LEVEL_CREATE_DESC: "requires 'Print Mailings: Create new'",
  RIGHT_VAR_PRINT_MAIL_TOP_LEVEL_CREATE_NAME: "Print Mailings: Create new at root level",
  RIGHT_VAR_RESUBMISSION_OTHER_EDIT_DESC: "requires 'Resubmissions: Create for self and edit'",
  RIGHT_VAR_RESUBMISSION_OTHER_EDIT_NAME: "Resubmissions: Create for other users",
  RIGHT_VAR_RESUBMISSION_OTHER_SEE_DESC: "",
  RIGHT_VAR_RESUBMISSION_OTHER_SEE_NAME: "Resubmissions: List others users' entries (Dashboard)",
  RIGHT_VAR_RESUBMISSION_SELF_EDIT_DESC: "",
  RIGHT_VAR_RESUBMISSION_SELF_EDIT_NAME: "Resubmissions: Create for self and edit",
  RIGHT_VAR_SEARCH_CREATE_DESC: "",
  RIGHT_VAR_SEARCH_CREATE_NAME: "Searches: Create new",
  RIGHT_VAR_SEARCH_DELETE_DESC: "",
  RIGHT_VAR_SEARCH_DELETE_NAME: "Searches: Delete",
  RIGHT_VAR_SEARCH_EDIT_DESC: "",
  RIGHT_VAR_SEARCH_EDIT_NAME: "Searches: Edit",
  RIGHT_VAR_TREE_CAMPAIGN_MOVE_DESC: "",
  RIGHT_VAR_TREE_CAMPAIGN_MOVE_NAME: "Campaigns menu: Move object",
  RIGHT_VAR_TREE_SEARCH_MOVE_DESC: "",
  RIGHT_VAR_TREE_SEARCH_MOVE_NAME: "People menu: Move object",
  SETTINGS_CONTACTS_ALL_SELECTED_HINT: "all fields have been selected",
  SETTINGS_CONTACTS_NO_SELECTED_HINT: "Select at least one field to show",
  SETTINGS_CONTACTS_NUM_SELECTED: "Selected: {0}",
  SETTINGS_CONTACTS_SECTION: "Contacts",
  SETTINGS_GENERAL_SECTION: "General",
  SETTINGS_OTHER_SECTION: "Other",
  SETTINGS_RESET_DEFAULT_TT: "Reset to default settings",
  SETTINGS_SAVE: "Save settings",
  SETTINGS_TITLE: "Settings",
  SAVEAS_DIALOG_CAMPAIGN: "Campaign",
  SAVEAS_DIALOG_CAMPAIGN_DD_NONE: "[none]",
  SAVEAS_DIALOG_CANCEL: "Cancel",
  SAVEAS_DIALOG_NAME: "Name",
  SAVEAS_DIALOG_NAME_EXISTS: "This name already exists",
  SAVEAS_DIALOG_NAME_TT: "Enter the name to be saved here.",
  SAVEAS_DIALOG_SAME_NAME: "This is the current name",
  SAVEAS_DIALOG_SAVE: "Save",
  SAVEAS_DIALOG_SAVE_TT: "A new entry will be created under the name given above.",
  TEMPLATE_GUIDE_CLIPBOARD_OK_SB: "Placeholder copied",
  TEMPLATE_GUIDE_CLIPBOARD_ERROR_SB: "Can not copy placeholder",
  TEMPLATE_GUIDE_CURRENT_DATE: "Current date",
  TEMPLATE_GUIDE_FOOTER: "Click on any field to copy its placeholder code into the system clipboard. You can then paste it into the template text via Ctrl+V.",
  TEMPLATE_GUIDE_ID: "Person ID (internal)",
  TEMPLATE_GUIDE_LOGINNAME: "Loginname",
  TEMPLATE_GUIDE_SPECIAL_FIELDS: "Special fields",
  TEMPLATE_GUIDE_TAGLINE: "List of fields that can be inserted into a mailing template:",
  TEMPLATE_GUIDE_TITLE: "Placeholders",
  TEMPLATE_GUIDE_UNSUBSCRIBE_LINK: "Unsubscribe link",
  TEMPLATE_GUIDE_WEBVIEW: "Link to the web view of the mailing",
  TEMPLATE_SEARCH_BTN_NO_TEMPLATE: "Deselect template",
  TEMPLATE_SEARCH_HEAD: "Browse mailing templates",
  TEMPLATE_SEARCH_LABEL: "Template title contains",
  TEMPLATE_SEARCH_LANG: "Template language",
  TEMPLATE_SEARCH_OFFLINE: "@it object is offline",
  TEMPLATE_SEARCH_ONLINE: "@it object is online",
  TEMPLATE_SEARCH_RESULTS_MANY: "{0} objects found.",
  TEMPLATE_SEARCH_RESULTS_ONE: "1 object found.",
  TEMPLATE_SEARCH_RESULTS_TOOMANY: "{0}+ objects found. Please refine your search.",
  TEMPLATE_SEARCH_RESULTS_TOOMANY_2: "Found {0} templates, showing only first {1}. Please refine your search.",
  TEMPLATE_SEARCH_SEARCH: "Search",
  TESTMAIL_CLEAR_INPUT: "Reset settings",
  TESTMAIL_CONFIRM: "A preview of this mailing will be sent to {0} recipients. Do you want to continue?",
  TESTMAIL_CONFIRM_TITLE: "Confirm preview dispatch",
  TESTMAIL_DD_PROMPT: "Drag&Drop from 'People'",
  TESTMAIL_DISPATCHING: "Mailing is being dispatched...",
  TESTMAIL_DISPATCH_CONFIRMATION: "Dispatch confirmation",
  TESTMAIL_DRAG_SEARCH_TT: "Drag a search or contact group from the main navigation into this area.",
  TESTMAIL_HEADER: "Preview dispatch",
  TESTMAIL_HINT_PITFALLS: "Please note that emails will only be sent to contacts, which have the 'emails enabled' option enabled and which have not been flagged as 'Bounced'.",
  TESTMAIL_HINT_SAVED_SEARCH: "Drag a saved search or contact group from the left-hand navigation column into the field 'To selection'. The number of recipients will be calculated automatically.",
  TESTMAIL_HINT_SEARCH: "Type a search or contact group name from the People list into the field 'To selection'. The number of recipients will be calculated automatically.",
  TESTMAIL_HINT_TYPE_EMAIL: "1. Select a sample contact from the database, which will be used to populate the placeholders in the mailing template.\n2. Enter one or multiple email addresses (separated by commas) in the field 'To email'.",
  TESTMAIL_INPUT_MISSING: "Incomplete input.",
  TESTMAIL_MAILING_FAILED: "The mailing dispatch failed.",
  TESTMAIL_MAILS_SENT: "emails sent",
  TESTMAIL_MAIL_SENT: "email sent",
  TESTMAIL_PREVIEW_CONTACT: "Template recipient",
  TESTMAIL_PREVIEW_PREFIX: "Add 'Preview'-prefix to subject",
  TESTMAIL_SEND: "Send",
  TESTMAIL_TOO_MANY_RECIPIENTS: "A preview mailing can be dispatched to a maximum of {0} recipients. Please use a different contact selection.",
  TESTMAIL_TOO_MANY_RECIPIENTS_TITLE: "Too many recipients",
  TESTMAIL_TO_EMAIL: "To email",
  TESTMAIL_TO_SEARCH: "To selection",
  TESTMAIL_WIZARD_ANY_ADDRESS: "User-defined email addresses",
  TESTMAIL_WIZARD_CONTACTS: "Contacts from the CRM",
  TESTMAIL_WIZARD_CONTACT_GROUP: "Saved contact group",
  TESTMAIL_WIZARD_QUESTION: "Who is going to receive a preview of this mailing?",
  TESTMAIL_WIZARD_SAVED_SEARCH: "Saved search",
  TESTMAIL_WIZARD_TO_MYSELF: "To myself",
  TESTMAIL_WIZARD_TYPE_EMAILS: "Enter addresses manually",
  TESTMAIL_ZERO_RECIPIENTS: "The chosen search does not yield any results, i.e. there are no recipients.",
  TESTMAIL_ZERO_RECIPIENTS_TITLE: "No recipients",
  TOOLBAR_MENU_HOME: "Home",
  TOOLBAR_MENU_DASHBOARD: "Dashboard",
  TOOLBAR_MENU_MAILINGS: "Mailings",
  TOOLBAR_MENU_SETTINGS: "Settings",
  TOOLBAR_MENU_QUIT_SESSION: "Quit session",
  WIDGET_CORE_BTN_CONFIG_TT: "Configure widget",
  WIDGET_CORE_BTN_DASH_ADD_TT: "Add widget",
  WIDGET_CORE_BTN_DASH_CONFIG_TT: "Configure My Dashboard",
  WIDGET_CORE_BTN_DASH_DONE_TT: "Done",
  WIDGET_CORE_BTN_DASH_MULTI_TT: "Configure multiple dashboards",
  WIDGET_CORE_BTN_DEFAULT_CONFIG: "Default configuration",
  WIDGET_CORE_BTN_MOVE_TT: "Drag to place widget",
  WIDGET_CORE_BTN_REMOVE_TT: "Remove widget from dashboard",
  WIDGET_CORE_BTN_RESIZE_TT: "Drag to resize widget",
  WIDGET_CORE_BTN_TIDY_OUTSIDE: "Remove overlapping widgets",
  WIDGET_CORE_CONFIG_POPUP_TITLE: "Configure widget",
  WIDGET_CORE_DELETE_ALERT: "The widget '{0}' will be removed from your personal dashboard.",
  WIDGET_CORE_HINT_ADD: "Add widgets individually by clicking the 'plus' symbol.",
  WIDGET_CORE_HINT_ADD_DEFAULT: "Alternatively click the button below to restore the default configuration.",
  WIDGET_CORE_HINT_CONFIG: "This dashboard is empty. You can configure it by clicking the 'gears' symbol in the top right.",
  WIDGET_CORE_HINT_WIDGETS_OUTSIDE: "Some widgets are placed outside of the visible bounds. Click on the button below to remove these from the dashboard.",
  WIDGET_CORE_LIMIT_TT: "You cannot place any more widgets of type '{0}'",
  WIDGET_CORE_MOVE_DELETE_TT: "Remove widget from dashboard",
  WIDGET_CORE_MOVE_PLACE_TT: "Drag to place widget",
  WIDGET_CORE_MULTICONFIG_ADD_BOARD: "Add new dashboard",
  WIDGET_CORE_MULTICONFIG_DELETE_ALERT: "Do you really want to delete this dashboard configuration?",
  WIDGET_CORE_MULTICONFIG_DELETE_TT: "Remove dashboard",
  WIDGET_CORE_MULTICONFIG_HINT: "Rename or delete personal dashboards here. Change the order of boards via drag&drop.",
  WIDGET_CORE_MULTICONFIG_MAX_HINT: "You cannot add more than {0} dashboards.",
  WIDGET_CORE_MULTICONFIG_UNNAMED: "[Unnamed dashboard]",
  WIDGET_CORE_TIDY_ALERT: "Attention: Widgets which are only partly visible will also be removed. Number of widgets to remove: {0}",
  WIDGET_INFO_MAILDISP_DESC: "Diplays the progress of any active mailing dispatch. If no dispatch is running, it shows the last and next scheduled dispatches.",
  WIDGET_INFO_MAILDISP_NAME: "Dispatch status",
  WIDGET_INFO_POSTIT_DESC: "Put a text memo on your dashboard.",
  WIDGET_INFO_POSTIT_NAME: "Sticky note",
  WIDGET_INFO_REPORT_DESC: "Displays a saved report in miniature format.",
  WIDGET_INFO_REPORT_NAME: "Mini report",
  WIDGET_INFO_RESUB_DESC: "Displays a list of all resubmissions. Also allows the creation of free resubmissions (not attached to a specific contact).",
  WIDGET_INFO_RESUB_NAME: "Resubmissions",
  WIDGET_MAILDISP_INIT: "Retrieving dispatch status...",
  WIDGET_MAILDISP_NO_PREVIOUS: "No mailing has been dispatched yet.",
  WIDGET_MAILDISP_NO_UPCOMING: "No dispatch is scheduled at the moment.",
  WIDGET_MAILDISP_PREVIOUS_TT: "Previous dispatch",
  WIDGET_MAILDISP_TITLE: "Dispatch status",
  WIDGET_MAILDISP_UPCOMING_TT: "Next dispatch",
  WIDGET_POSTIT_EDIT_TT: "Click outside of the memo to exit text input",
  WIDGET_POSTIT_MAIN_TT: "Double click to edit text",
  WIDGET_REPORT_CHOOSE_REPORT: "[Select saved report...]",
  WIDGET_REPORT_NOT_CONFIGURED: "Report not configured",
  WIDGET_REPORT_OPTIONS: "Display options",
  WIDGET_REPORT_OPTION_BARCOLOR: "Bar color (for column and bar charts)",
  WIDGET_REPORT_TEMPLATE: "Report template",
  WIDGET_REPORT_WARN_NO_REPORTS: "You have not yet created any saved reports. Go to the Reporting dashboard in order to configure a report and save it. You can then select it as a template here.",
  WIDGET_REPORT_WARN_OLD_TITLE: "The saved report used in this widget has been renamed or deleted. Please amend the configuration.",
  WIDGET_RESUB_CHK_SHOW_DONE: "Show done entries",
  WIDGET_RESUB_EMPTY_LIST: "No resubmissions",
  WIDGET_RESUB_LIST_SHOW_ALL: "[All resubmissions]",
  WIDGET_RESUB_TITLE: "Resubmissions",
  NO_DATA: "No data has been collected in the selected period.",
}

export default en
